import { render, staticRenderFns } from "./upcountryPlanSettings.vue?vue&type=template&id=fe3978f0&scoped=true"
import script from "./upcountryPlanSettings.vue?vue&type=script&lang=js"
export * from "./upcountryPlanSettings.vue?vue&type=script&lang=js"
import style0 from "./upcountryPlanSettings.vue?vue&type=style&index=0&id=fe3978f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3978f0",
  null
  
)

export default component.exports